import { render, staticRenderFns } from "./AdminPanelMegogoList.vue?vue&type=template&id=3a121f27&"
import script from "./AdminPanelMegogoList.vue?vue&type=script&lang=js&"
export * from "./AdminPanelMegogoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports